import { render, staticRenderFns } from "./RewardHistoryBlock.vue?vue&type=template&id=3332c4b4&scoped=true&"
import script from "./RewardHistoryBlock.vue?vue&type=script&lang=js&"
export * from "./RewardHistoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./RewardHistoryBlock.vue?vue&type=style&index=0&id=3332c4b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3332c4b4",
  null
  
)

export default component.exports